const parseJsonString = (jsonString) => {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    return jsonString;
  }
};

export const buildResponseVariablesForTooltip = (testCaseSetList, testCaseSetId) => {
  let responseVariablesObject = {};

  let index = 0;
  while (index < testCaseSetList.length) {
    if (testCaseSetList[index].id === testCaseSetId) {
      break;
    }

    const currentTestCase = testCaseSetList[index];
    const response = currentTestCase.test_case_set_response;

    // Handle status
    responseVariablesObject[`response${index + 1}_status`] = response?.status;

    // Handle headers
    if (response?.headers) {
      responseVariablesObject[`response${index + 1}_headers`] = response.headers;
    }

    // Handle body
    if (response?.body) {
      responseVariablesObject[`response${index + 1}_body`] = parseJsonString(response.body);
    }

    index += 1;
  }

  // Current response
  const currentResponse = testCaseSetList[index].test_case_set_response;

  // Handle current response status
  responseVariablesObject["current_response_status"] = currentResponse?.status;

  // Handle current response headers
  if (currentResponse?.headers) {
    responseVariablesObject["current_response_headers"] = currentResponse.headers;
  }

  // Handle current response headers
  if (currentResponse?.request_started_at) {
    responseVariablesObject["current_request_started_at"] = currentResponse.request_started_at;
  }

  // Handle current response headers
  if (currentResponse?.request_body) {
    responseVariablesObject["current_request_body"] = currentResponse.request_body;
  }

  // Handle current response body
  if (currentResponse?.body) {
    responseVariablesObject["current_response_body"] = parseJsonString(currentResponse.body);
  }

  // Handle current request time
  responseVariablesObject["current_request_time"] = currentResponse?.time_in_ms;

  return responseVariablesObject;
};
